export type DataGridSettings = {
  /**
   * Defines how value in cell is handled if cell is too narrow
   * - TRUNCATE: removes excess text and show ellipsis sign
   * - WRAP: value is wraped to multiple layers
   * INFO: Wrap option is not fully implemented and is considered for DGv5
   */
  valueWrapping: 'TRUNCATE' | 'WRAP';
  /* Enables inline editing - INFO: this feature is not fully implemented and is considered for DGv5 */
  inlineEdit: boolean;
  /* Enables column resizing for all columns */
  columnResizing: boolean;
  /* Number of rows per page, datagrid will use infinite model when page size is null */
  pageSize: number | null;
  /* Visibility of row (horizontal) separators */
  horizontalSeparators: boolean;
  /* Visibility of column (vertical) separators */
  verticalSeparators: boolean;
  /* Height of each row in pixels */
  rowHeight: number;
  /* Visibility of alterning row backgrouns */
  rowZebra: boolean;
  /* Keyboard navigation in table */
  keyboardNavigation: boolean;
  /* Conditional formating of cells */
  conditionalFormatting: boolean;
  /* Rangle selection of cells used to copy values or create charts */
  rangeSelection: boolean;
  /* Controlls if user can use charts */
  charts: boolean;
  aggregationFuncInHeader: boolean;
  /**
   * Defines mode of row selection
   * - single: only one row can be selected at a time
   * - multiple: more rows can be selected at the same time
   * - none: no rows can be selected and selector column is hidden
   */
  rowSelection: 'SINGLE' | 'MULTIPLE' | 'NONE';
  /**
   * Controlls if master detail can be used:
   * - NONE: master detail is not enabled
   * - SINGLE_ROWS: only one master detail can be shown at a time
   * - MULTIPLE_ROWS: more master details can be shown at the same time
   */
  masterDetail: 'SINGLE_ROWS' | 'MULTIPLE_ROWS' | 'NONE';
  /* Visibility of smart search */
  smartSearch: boolean;
  /* visibility of filter tool panel */
  toolPanelFilter: boolean;
  /* visibility of columns tool panel */
  toolPanelColumn: boolean;
  /* visibility of settings tool panel */
  toolPanelSettings: boolean;
  /* visibility of presets panel */
  presets: boolean;
  /* visibility of column groups in header */
  columnGroupsInHeader: boolean;
  /**
   * Defines how DG is rendered
   * - card: DG is rendered in card with white BG, box shadow and round corners
   * - inline: DG is rendered as is without a card effect
   */
  datagridWrapperStyle: 'CARD' | 'INLINE';
  /* Height of header in pixels */
  headerHeight: number;
  /* Controlls ability to pin columns */
  columnPinning: boolean;
  /* Controlls ability to move columns */
  columnMoving: boolean;
  /* Controlls ability to hide or show columns */
  columnHiding: boolean;
  /* Visibility of auto size function */
  columnAutoResizing: boolean;
  /* Visibility of custom context menu */
  contextMenu: boolean;
  /* Visibility of column menu, NOTE: this is not Columns tool panel */
  columnMenu: boolean;
  /**
   * Should disable ability of user to use clipboard to dump data from table
   * NOTE: this feature is not implemented yet, you can use rangeSelection option to prevent users to dump data from DG
   */
  clipboard: boolean;
  /**
   * Controlls ability to sort data by columns:
   * - SINGLE_SORT: data can be sorted by only one column at a time
   * - MULTI_SORT: data can be sorted by multiple columns
   * - NONE: data cannot be sorted by any column
   */
  columnSorting: 'SINGLE_SORT' | 'MULTI_SORT' | 'NONE';
  /* Visibility of fit to screen function */
  columnFitToScreen: boolean;
  /* Visibility of pagination */
  pagination: boolean;
  /* Visibility of row actions */
  actions: boolean;
  /**
   * Defines how filters are handled
   * - NATIVE: Native filters provided by Ag-Grid
   * - CUSTOM: Custom filters mainly handled by UI-Builder
   */
  filterType: 'NATIVE' | 'CUSTOM';
  /* Visibility of staturs bar */
  statusBarVisible: boolean;
};
